import * as React from "react"

const BagIcon = ({...props}) => (
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    viewBox="0 0 32 32"
    {...props}
>
    <path
      fill="#25b39e"
      d="M6 10v19h2V17.5A1.5 1.5 0 0 1 9.5 16H21v-6h-2.027A2.502 2.502 0 0 1 20 12c0 1.363-1.137 2.5-2.5 2.5A2.523 2.523 0 0 1 15 12c0-.814.41-1.541 1.027-2h-5.054A2.502 2.502 0 0 1 12 12c0 1.363-1.137 2.5-2.5 2.5A2.523 2.523 0 0 1 7 12c0-.814.41-1.541 1.027-2zm3.5 1.5c-.258 0-.5.242-.5.5 0 .259.242.5.5.5s.5-.241.5-.5c0-.258-.242-.5-.5-.5zm8 0c-.258 0-.5.242-.5.5 0 .259.242.5.5.5s.5-.241.5-.5c0-.258-.242-.5-.5-.5z"
    />
    <path
      fill="#f8b84e"
      style={{
        isolation: "auto",
        mixBlendMode: "normal",
      }}
      d="M11 1039.362v10h9.479c-3.029 0-5.522-2.473-5.522-5.498v-1.06a2.494 2.494 0 0 1-.957-1.942c0-.561.2-1.079.521-1.5H11zm9.479 10H29v-10h-2.521c.321.421.521.939.521 1.5 0 .802-.399 1.517-1 1.977v1.025c0 3.025-2.493 5.498-5.521 5.498zm-2-10c.321.421.521.939.521 1.5 0 .822-.416 1.556-1.043 2.014v.988c0 1.406 1.094 2.498 2.522 2.498 1.427 0 2.521-1.092 2.521-2.498v-1.025c-.601-.46-1-1.175-1-1.977 0-.561.2-1.079.521-1.5H18.48zm-1.979 1h-.01.02-.01zm8 0h-.01.02-.01z"
      color="#000"
      overflow="visible"
      transform="translate(0 -1020.362)"
    />
    <path
      style={{
        lineHeight: "normal",
        textIndent: 0,
        textAlign: "start",
        textDecorationLine: "none",
        textDecorationStyle: "solid",
        textDecorationColor: "#000",
        textTransform: "none",
        msBlockProgression: "tb",
        isolation: "auto",
        mixBlendMode: "normal",
      }}
      d="M5.5 1028.361c-.822 0-1.5.678-1.5 1.5v20c0 .823.678 1.5 1.5 1.5h17a.5.5 0 1 0 0-1h-17a.488.488 0 0 1-.5-.5v-20c0-.285.214-.5.5-.5h16c.286 0 .5.215.5.5v7.914a.5.5 0 1 0 1 0v-7.914c0-.822-.678-1.5-1.5-1.5h-16z"
      color="#000"
      fontFamily="sans-serif"
      fontWeight={400}
      overflow="visible"
      transform="translate(0 -1020.362)"
    />
    <path
      style={{
        lineHeight: "normal",
        textIndent: 0,
        textAlign: "start",
        textDecorationLine: "none",
        textDecorationStyle: "solid",
        textDecorationColor: "#000",
        textTransform: "none",
        msBlockProgression: "tb",
        isolation: "auto",
        mixBlendMode: "normal",
      }}
      d="M9.5 1030.861c-.823 0-1.5.678-1.5 1.5 0 .823.677 1.5 1.5 1.5s1.5-.677 1.5-1.5c0-.822-.677-1.5-1.5-1.5zm0 1c.282 0 .5.218.5.5 0 .282-.218.5-.5.5a.493.493 0 0 1-.5-.5c0-.282.218-.5.5-.5zm8-1c-.823 0-1.5.678-1.5 1.5 0 .823.677 1.5 1.5 1.5s1.5-.677 1.5-1.5c0-.822-.677-1.5-1.5-1.5zm0 1c.282 0 .5.218.5.5 0 .282-.218.5-.5.5a.493.493 0 0 1-.5-.5c0-.282.218-.5.5-.5z"
      color="#000"
      fontFamily="sans-serif"
      fontWeight={400}
      overflow="visible"
      transform="translate(0 -1020.362)"
    />
    <path
      style={{
        lineHeight: "normal",
        textIndent: 0,
        textAlign: "start",
        textDecorationLine: "none",
        textDecorationStyle: "solid",
        textDecorationColor: "#000",
        textTransform: "none",
        msBlockProgression: "tb",
        isolation: "auto",
        mixBlendMode: "normal",
      }}
      d="M13.521 1022.361c-2.494 0-4.521 2.015-4.521 4.5v5h1v-5c0-1.945 1.56-3.5 3.521-3.5a3.493 3.493 0 0 1 3.522 3.5v5h1v-5c0-2.485-2.027-4.5-4.522-4.5zm-11.021 6c-.822 0-1.5.678-1.5 1.5v.012c.005.653.431 1.223 1.035 1.51a2.26 2.26 0 0 0 1.93 0c.604-.285 1.03-.855 1.035-1.508v-.012c0-.286.214-.5.5-.5a.5.5 0 0 0 .05 0 .5.5 0 0 0 .143-.039.5.5 0 0 0 .045-.023.5.5 0 0 0 .15-.129.5.5 0 0 0 .03-.04.5.5 0 0 0 .023-.046.5.5 0 0 0 .045-.142.5.5 0 0 0 .006-.05.5.5 0 0 0-.13-.367.5.5 0 0 0-.362-.166h-3zm0 1h1.709c-.069.172-.209.306-.209.5v.01c-.002.223-.146.46-.465.612-.32.152-.75.152-1.07 0-.319-.154-.463-.39-.465-.614v-.01c0-.286.214-.5.5-.5z"
      color="#000"
      fontFamily="sans-serif"
      fontWeight={400}
      overflow="visible"
      transform="translate(0 -1020.362)"
    />
    <path
      style={{
        lineHeight: "normal",
        textIndent: 0,
        textAlign: "start",
        textDecorationLine: "none",
        textDecorationStyle: "solid",
        textDecorationColor: "#000",
        textTransform: "none",
        msBlockProgression: "tb",
        isolation: "auto",
        mixBlendMode: "normal",
      }}
      d="M11.521 1021.361c-2.494 0-4.521 2.015-4.521 4.5v3.366h1v-3.366c0-1.945 1.56-3.5 3.521-3.5a3.493 3.493 0 0 1 3.522 3.5v3.366h1v-3.366c0-2.485-2.027-4.5-4.522-4.5zm-9.021 7c-.822 0-1.5.678-1.5 1.5v20c0 .823.678 1.5 1.5 1.5h3v-1a.488.488 0 0 1-.5-.5v-20c0-.285.214-.5.5-.5v-1h-3zm0 1h1.709c-.069.172-.209.306-.209.5v20c0 .195.14.33.209.5H2.5a.488.488 0 0 1-.5-.5v-20c0-.285.214-.5.5-.5zm7 8a.5.5 0 0 0-.5.5v13a.5.5 0 0 0 .346.475.5.5 0 0 0 .049.014.5.5 0 0 0 .1.012.5.5 0 0 0 .005 0h21a.5.5 0 0 0 .05 0 .5.5 0 0 0 .05-.01.5.5 0 0 0 .4-.49v-13l-.008.01a.5.5 0 0 0-.492-.51h-21zm.5 1h20v12H10v-12z"
      color="#000"
      fontFamily="sans-serif"
      fontWeight={400}
      overflow="visible"
      transform="translate(0 -1020.362)"
    />
    <path
      style={{
        lineHeight: "normal",
        textIndent: 0,
        textAlign: "start",
        textDecorationLine: "none",
        textDecorationStyle: "solid",
        textDecorationColor: "#000",
        textTransform: "none",
        msBlockProgression: "tb",
        isolation: "auto",
        mixBlendMode: "normal",
      }}
      d="M15.957 1041.363v2.5c0 2.486 2.027 4.498 4.522 4.498 2.494 0 4.521-2.012 4.521-4.498v-2.5h-1v2.5c0 1.946-1.56 3.498-3.521 3.498-1.962 0-3.522-1.552-3.522-3.498v-2.5h-1z"
      color="#000"
      fontFamily="sans-serif"
      fontWeight={400}
      overflow="visible"
      transform="translate(0 -1020.362)"
    />
    <path
      style={{
        lineHeight: "normal",
        textIndent: 0,
        textAlign: "start",
        textDecorationLine: "none",
        textDecorationStyle: "solid",
        textDecorationColor: "#000",
        textTransform: "none",
        msBlockProgression: "tb",
        isolation: "auto",
        mixBlendMode: "normal",
      }}
      d="M16.5 1039.361c-.823 0-1.5.678-1.5 1.5 0 .823.677 1.5 1.5 1.5s1.5-.677 1.5-1.5c0-.822-.677-1.5-1.5-1.5zm0 1c.282 0 .5.218.5.5 0 .282-.218.5-.5.5a.493.493 0 0 1-.5-.5c0-.282.218-.5.5-.5zm8-1c-.823 0-1.5.678-1.5 1.5 0 .823.677 1.5 1.5 1.5s1.5-.677 1.5-1.5c0-.822-.677-1.5-1.5-1.5zm0 1c.282 0 .5.218.5.5 0 .282-.218.5-.5.5a.493.493 0 0 1-.5-.5c0-.282.218-.5.5-.5z"
      color="#000"
      fontFamily="sans-serif"
      fontWeight={400}
      overflow="visible"
      transform="translate(0 -1020.362)"
    />
  </svg>
)

export default BagIcon